import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import { FiInfo, FiAlertTriangle, FiXCircle, FiCheckCircle } from 'react-icons/fi';

const ALERT_TYPES = {
  info: {
    icon: FiInfo,
    label: 'Info',
    className: 'alert-block-info',
  },
  warning: {
    icon: FiAlertTriangle,
    label: 'Warning',
    className: 'alert-block-warning',
  },
  error: {
    icon: FiXCircle,
    label: 'Error',
    className: 'alert-block-error',
  },
  success: {
    icon: FiCheckCircle,
    label: 'Success',
    className: 'alert-block-success',
  },
};

// Alert Node View Component
const AlertNodeView = ({ node, updateAttributes, selected }) => {
  const type = node.attrs.type || 'info';
  const content = node.attrs.content || '';
  const alertConfig = ALERT_TYPES[type];
  const Icon = alertConfig.icon;

  const handleTypeChange = (newType) => {
    updateAttributes({ type: newType });
  };

  const handleContentChange = (e) => {
    updateAttributes({ content: e.target.value });
  };

  return (
    <NodeViewWrapper className={`alert-block ${alertConfig.className} ${selected ? 'selected' : ''}`}>
      <div className="alert-type-selector">
        {Object.entries(ALERT_TYPES).map(([key, config]) => {
          const TypeIcon = config.icon;
          return (
            <button
              key={key}
              type="button"
              className={`alert-type-btn ${type === key ? 'active' : ''}`}
              onClick={() => handleTypeChange(key)}
              title={config.label}
            >
              <TypeIcon size={14} />
            </button>
          );
        })}
      </div>
      <div className="alert-icon">
        <Icon size={20} />
      </div>
      <div className="alert-content">
        <textarea
          value={content}
          onChange={handleContentChange}
          placeholder={`Enter ${alertConfig.label.toLowerCase()} message...`}
          className="alert-textarea"
          rows={2}
        />
      </div>
    </NodeViewWrapper>
  );
};

// Alert Extension
export const Alert = Node.create({
  name: 'alert',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      type: {
        default: 'info',
      },
      content: {
        default: '',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="alert"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'alert' }), 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(AlertNodeView);
  },

  addCommands() {
    return {
      insertAlert:
        (attrs = {}) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              type: attrs.type || 'info',
              content: attrs.content || 'Enter your message here...',
            },
          });
        },
    };
  },
});

export default Alert;
